import LatLngLiteral = google.maps.LatLngLiteral;

export class TripLatng {

  public origin: LatLngLiteral;

  public destination: LatLngLiteral;

  static fromDto(d): TripLatng {
    const tripLatng = new TripLatng();

    tripLatng.origin = d.origin ? {
      lat: d.origin.latitude,
      lng: d.origin.longitude
    } : null;

    tripLatng.destination = d.destination ? {
      lat: d.destination.latitude,
      lng: d.destination.longitude
    } : null;

    return tripLatng;
  }

}
